var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Shipping details for order "+_vm._s(_vm.getId()))]),_c('OrderShippingEditor',{staticClass:"margin-top",attrs:{"order":_vm.getId(),"autoload":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }